import { Phone, Mail, MapPin, Globe, Instagram, Facebook, Youtube } from "lucide-react";
import { NAV_LINKS, BRANCHES, CONTACT } from "@/data/content";

const SOCIAL_ICONS = { Instagram, Facebook, YouTube: Youtube };

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] border-t border-[#FF5A1F]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <a href="#home" data-testid="footer-logo-link" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-[#FF5A1F] flex items-center justify-center">
                <span className="font-wordmark text-[#0A0A0A] text-[13px] leading-none">F12</span>
              </span>
              <span className="font-wordmark text-2xl leading-none text-[#FF5A1F]">
                F12<span className="font-semibold">Fitness</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-[#D1D1D1]">
              F12 FITNESS is a premium fitness destination built to help you become stronger,
              healthier and more confident — across every branch.
            </p>
            <div className="mt-5 flex items-center gap-3">
              {CONTACT.socials.map((s) => {
                const Icon = SOCIAL_ICONS[s.label];
                return (
                  <a
                    key={s.label}
                    data-testid={`footer-social-${s.label.toLowerCase()}-link`}
                    href={s.href}
                    aria-label={`F12 FITNESS on ${s.label}`}
                    className="w-9 h-9 rounded-full bg-[#141414] border border-white/10 flex items-center justify-center text-[#D1D1D1] hover:text-white hover:bg-[#FF5A1F] hover:border-[#FF5A1F] transition-colors"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <nav data-testid="footer-quick-links" aria-label="Quick links">
            <h3 className="font-heading text-xl tracking-wider text-white uppercase">Quick Links</h3>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    data-testid={`footer-${l.label.toLowerCase()}-link`}
                    href={l.href}
                    className="text-sm text-[#D1D1D1] hover:text-[#FF5A1F] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-xl tracking-wider text-white uppercase">Branches</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-[#D1D1D1]">
              {BRANCHES.map((b) => (
                <li key={b.id}>
                  <a
                    data-testid={`footer-branch-${b.id}-link`}
                    href="#branches"
                    className="hover:text-[#FF5A1F] transition-colors"
                  >
                    {b.name}
                    <span className={b.status === "OPEN" ? "text-emerald-400" : "text-[#FF5A1F]"}>
                      {" "}— {b.status === "OPEN" ? "Open" : "Opening Soon"}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-xl tracking-wider text-white uppercase">Contact</h3>
            <ul className="mt-4 space-y-3 text-sm text-[#D1D1D1]">
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 text-[#FF5A1F] mt-0.5 shrink-0" />
                Thiruvananthapuram, Kerala
              </li>
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 text-[#FF5A1F] mt-0.5 shrink-0" />
                <a
                  data-testid="footer-phone-link"
                  href={CONTACT.phoneHref}
                  className="hover:text-[#FF5A1F] transition-colors"
                >
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 text-[#FF5A1F] mt-0.5 shrink-0" />
                <a
                  data-testid="footer-email-link"
                  href={CONTACT.emailHref}
                  className="hover:text-[#FF5A1F] transition-colors"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Globe className="w-4 h-4 text-[#FF5A1F] mt-0.5 shrink-0" />
                <a
                  data-testid="footer-website-link"
                  href={CONTACT.websiteHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#FF5A1F] transition-colors"
                >
                  {CONTACT.websiteDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p data-testid="footer-copyright" className="text-xs text-[#8E8E93]">
            © {new Date().getFullYear()} F12 FITNESS. All rights reserved.
          </p>
          <p className="text-xs text-[#8E8E93]">
            Transform Your Body. Elevate Your Life.
          </p>
        </div>
      </div>
    </footer>
  );
}
